function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#a62731",
  d: "M24.132 13.149H8.045a.625.625 0 01-.625-.624V9.683c0-.637.518-1.156 1.155-1.156h15.026c.638 0 1.156.519 1.156 1.156v2.843a.624.624 0 01-.625.623zM8.575 11.994h15.026V9.683H8.575v2.311z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a62731",
  d: "M16.088 29.91a4.052 4.052 0 01-4.046-4.047v-7.871l-4.477-5.037.864-.768 4.769 5.366v8.31a2.893 2.893 0 002.89 2.89 2.893 2.893 0 002.89-2.89v-8.31l4.769-5.366.864.768-4.478 5.037v7.871a4.05 4.05 0 01-4.045 4.047z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#a62731",
  d: "M15.511 20.663h1.155v3.467h-1.155zM8.575 6.215h1.156v1.156H8.575zM10.887 6.215h1.155v1.156h-1.155zM13.199 6.215h1.156v1.156h-1.156zM15.511 6.215h1.155v1.156h-1.155zM17.822 6.215h1.156v1.156h-1.156zM20.134 6.215h1.155v1.156h-1.155zM22.445 6.215h1.156v1.156h-1.156zM8.575 2.169h1.156v2.312H8.575zM10.887 2.169h1.155v2.312h-1.155zM13.199 2.169h1.156v2.312h-1.156zM15.511 2.169h1.155v2.312h-1.155zM17.822 2.169h1.156v2.312h-1.156zM20.134 2.169h1.155v2.312h-1.155zM22.445 2.169h1.156v2.312h-1.156z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#a62731",
  d: "M6.842 5.637h18.493v1.156H6.842z"
});

function SvgScanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgScanner;